// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { RoleResource } from "../schema";

export function serialize_RoleResource_internal(value: RoleResource): unknown {
  return ((
    value:
      | "ROLE_ADMIN"
      | "PPS_EDITORIAL"
      | "PPS_RIGHTS"
      | "PPS_BOOKMARKETING"
      | "PPS_WRITERREPORT"
      | "PPS_STANDARDREPORT"
      | "PPS_ALLSUMMARIES_LIST"
      | "PPS_PUBLISHERADMIN"
      | "PPS_INTERNALSEARCH"
      | "ASP_ACCOUNT_ADMIN"
      | "PUBLISHER_STATS_ALL"
      | "ASP_STATISTICS"
      | "ASP_USER_ADMIN"
      | "PPS_RIGHTSADMINLIST"
      | "ASP_STATISTICS_INTERNAL"
      | "ADMIN_TOOL"
      | "CUSTOMER_ADMIN"
      | "EMAILTOOL"
      | "TRANSACTION_ADMIN"
      | "AFFILIATE_CLV_STATISTICS"
      | "MARKETING_FILE_UPLOAD"
      | "CURRENCY_EXCHANGE_RATE"
      | "PPS_EDITORREPORT"
      | "ADMIN_RELOAD"
      | "ASP_MASSIMPORT_TOOL"
      | "ASP_USER_ADMIN_LASTACCESS"
      | "ASP_CENTRAL_ADMIN"
      | "TXT_BUNDLE_EDIT"
      | "TXT_TEXT_SINGLEEDIT"
      | "TXT_TEXT_MULTIEDIT"
      | "TXT_TOBEREVIEWEDLIST"
      | "TXT_TOBETRANSLATEDLIST"
      | "TXT_INLINE_EDIT"
      | "TXT_LATEST_CHANGES"
      | "TXT_SEARCH"
      | "TXT_MAJOR_CHANGE"
      | "TXT_ONLINE_STATE"
      | "CREDIT_CARD_SETTLEMENT"
      | "TXT_BUNDLE_VIEW"
      | "EMAIL_LIST"
      | "SOCIAL_COMMENT_FLAG"
      | "CUSTOMER_WRITER"
      | "RECOMMENDER_EXPORT"
      | "KREC_EDIT"
      | "WEB_RIGHTS_REQUEST"
      | "SCORM_PACKAGE"
      | "PPS_VIEW"
      | "AFFILIATE_ADMIN"
      | "SUMMARY_QR_CODE"
      | "MARC_XML"
      | "REGENERATE_SUMMARY_FILES"
      | "HR_ADMIN_TOOL"
      | "SUMMARY_STATISTICS"
      | "CF_SUBSCRIPTIONS"
      | "ASP_SSO_DOMAIN"
      | "CUSTOMER_ADMIN_SUBSCRIPTION"
      | "CUSTOMER_ADMIN_FINANCE"
      | "OAUTH2_CLIENT_ADMIN"
      | "ASP_USER_GROUP_ADMIN"
      | "TOP_DOWNLOADS_TOOL"
      | "WRITER_PORTAL"
      | "ASP_LOGO_UPLOAD"
      | "PORTLET_ADMIN"
      | "PORTLET_SUPER_ADMIN"
      | "FREEABSTRACT_ADMIN_TOOL"
      | "PROMOBOXES_ADMIN"
      | "CORPORATE_CONTACT"
      | "CORPORATE_COMMENTS"
      | "PPS_NEW_CONTENT_INPUT"
      | "PPS_NEW_CONTENT_INPUT_ADMIN"
      | "ABSENCES_ADMIN"
      | "CHANNEL_ADMIN"
      | "PROMOBOXES"
      | "SSO_DOMAINS"
      | "PPS_PORTAL"
      | "PPS_PORTAL_ADMIN"
      | "CHANNEL_LIST"
      | "B2B_STATISTICS"
      | "LIBRARY_CONNECTOR"
      | "CHANNEL_ADMIN_GLOBAL"
      | "PPS_FREELANCER_CONTACT_TOOL"
      | "PPS_API_PRODUCTION_POINTS"
      | "PPS_API_PRODUCTION_POINTS_ADMIN"
      | "PPS_API_WRITING_OFFER"
      | "PPS_API_EDITING_OFFER"
      | "PPS_FLOW"
      | "PPS_FLOW_ADMIN"
      | "PPS_API_JOB"
      | "PPS_API_INVOICE"
      | "SCIM_TOKEN_VIEWER"
      | "PPS_API_OFFER"
      | "PRODUCTION_REPORT"
      | "PPS_RIGHTS_FLOW"
      | "PPS_AUTHOR_TOOL"
      | "GA_KNOWLEDGE_BASE"
      | "PPS_KNOWLEDGE_BASE"
      | "EDITORIAL_KNOWLEDGE_BASE"
      | "PPS_RIGHTS_TEAM_REPORTS"
      | "PPS_EDITORIAL_TEAM_REPORTS"
      | "PPS_API_SUMMARY_CREATION"
      | "PROMOTION_CODE_TOOL"
      | "PPS_GLOBAL_MOST_WANTED_SUMMARY_REPORT"
      | "ASP_LIST"
      | "PPS_USER_API"
      | "ASP_SENSITIVE_CONTENT"
      | "CHANNEL_ADMIN_SEARCH"
      | "PPS_TEAM_MOST_WANTED_EDITORIAL_SUMMARY_REPORT"
      | "PPS_PERSONAL_MOST_WANTED_EDITORIAL_SUMMARY_REPORT"
      | "PPS_TEAM_MOST_WANTED_RIGHTS_SUMMARY_REPORT"
      | "PPS_PERSONAL_MOST_WANTED_RIGHTS_SUMMARY_REPORT"
      | "ACTIONABLE_ADMIN"
      | "PPS_COMPONENT_DEMO"
      | "ASP_MASSIMPORT_TOOL_EXTENDED"
      | "ASP_UNIDENTIFIED_USER_ADMIN"
      | "PPS_PAYMENT_TOOL"
      | "HR_ADMIN_FULL_ACCESS"
      | "PPS_ORIGINAL_SUMMARY_FILE_ACCESS"
      | "CUSTOMER_REPORTS"
      | "PPS_ARCHIVING_SUMMARY"
      | "PPS_USER_BETA_TEST"
      | "ACTIONABLE_ADMIN_SEARCH"
      | "CUSTOM_PAGE_ADMIN"
      | "PPS_EXPENSE_TOOL"
      | "VERIFY_INPUT_TOOL"
      | "VERIFY_PUBLISH"
      | "VERIFY_UPLOAD"
      | "VERIFY_DASHBOARD"
      | "CSM_ADVANCED_SEARCH"
      | "VERIFY_VERIFICATION"
      | "VERIFY_EDITING"
      | "SUMMARIES_BULK_LOAD"
      | "ACTIONABLES_BULK_LOAD"
      | "VERIFY_BULK_LOAD"
      | "TAG_ADMIN"
      | "EXPERTVIDEO_ADMIN"
      | "MIAB_ADMIN"
      | "AUTHOR_READ"
      | "TAG_SUPER_ADMIN"
      | "SKILL_BOOST_ADMIN"
      | "TXT_READ_ONLY",
  ): unknown => {
    return value;
  })(value);
}
export function serialize_RoleResource(obj: RoleResource): string {
  return renderJsonWithNumbersAsBigint(serialize_RoleResource_internal(obj));
}
export function deserialize_RoleResource_internal(value: unknown): ParserResult<RoleResource> {
  return ((
    value: unknown,
  ): ParserResult<
    | "ROLE_ADMIN"
    | "PPS_EDITORIAL"
    | "PPS_RIGHTS"
    | "PPS_BOOKMARKETING"
    | "PPS_WRITERREPORT"
    | "PPS_STANDARDREPORT"
    | "PPS_ALLSUMMARIES_LIST"
    | "PPS_PUBLISHERADMIN"
    | "PPS_INTERNALSEARCH"
    | "ASP_ACCOUNT_ADMIN"
    | "PUBLISHER_STATS_ALL"
    | "ASP_STATISTICS"
    | "ASP_USER_ADMIN"
    | "PPS_RIGHTSADMINLIST"
    | "ASP_STATISTICS_INTERNAL"
    | "ADMIN_TOOL"
    | "CUSTOMER_ADMIN"
    | "EMAILTOOL"
    | "TRANSACTION_ADMIN"
    | "AFFILIATE_CLV_STATISTICS"
    | "MARKETING_FILE_UPLOAD"
    | "CURRENCY_EXCHANGE_RATE"
    | "PPS_EDITORREPORT"
    | "ADMIN_RELOAD"
    | "ASP_MASSIMPORT_TOOL"
    | "ASP_USER_ADMIN_LASTACCESS"
    | "ASP_CENTRAL_ADMIN"
    | "TXT_BUNDLE_EDIT"
    | "TXT_TEXT_SINGLEEDIT"
    | "TXT_TEXT_MULTIEDIT"
    | "TXT_TOBEREVIEWEDLIST"
    | "TXT_TOBETRANSLATEDLIST"
    | "TXT_INLINE_EDIT"
    | "TXT_LATEST_CHANGES"
    | "TXT_SEARCH"
    | "TXT_MAJOR_CHANGE"
    | "TXT_ONLINE_STATE"
    | "CREDIT_CARD_SETTLEMENT"
    | "TXT_BUNDLE_VIEW"
    | "EMAIL_LIST"
    | "SOCIAL_COMMENT_FLAG"
    | "CUSTOMER_WRITER"
    | "RECOMMENDER_EXPORT"
    | "KREC_EDIT"
    | "WEB_RIGHTS_REQUEST"
    | "SCORM_PACKAGE"
    | "PPS_VIEW"
    | "AFFILIATE_ADMIN"
    | "SUMMARY_QR_CODE"
    | "MARC_XML"
    | "REGENERATE_SUMMARY_FILES"
    | "HR_ADMIN_TOOL"
    | "SUMMARY_STATISTICS"
    | "CF_SUBSCRIPTIONS"
    | "ASP_SSO_DOMAIN"
    | "CUSTOMER_ADMIN_SUBSCRIPTION"
    | "CUSTOMER_ADMIN_FINANCE"
    | "OAUTH2_CLIENT_ADMIN"
    | "ASP_USER_GROUP_ADMIN"
    | "TOP_DOWNLOADS_TOOL"
    | "WRITER_PORTAL"
    | "ASP_LOGO_UPLOAD"
    | "PORTLET_ADMIN"
    | "PORTLET_SUPER_ADMIN"
    | "FREEABSTRACT_ADMIN_TOOL"
    | "PROMOBOXES_ADMIN"
    | "CORPORATE_CONTACT"
    | "CORPORATE_COMMENTS"
    | "PPS_NEW_CONTENT_INPUT"
    | "PPS_NEW_CONTENT_INPUT_ADMIN"
    | "ABSENCES_ADMIN"
    | "CHANNEL_ADMIN"
    | "PROMOBOXES"
    | "SSO_DOMAINS"
    | "PPS_PORTAL"
    | "PPS_PORTAL_ADMIN"
    | "CHANNEL_LIST"
    | "B2B_STATISTICS"
    | "LIBRARY_CONNECTOR"
    | "CHANNEL_ADMIN_GLOBAL"
    | "PPS_FREELANCER_CONTACT_TOOL"
    | "PPS_API_PRODUCTION_POINTS"
    | "PPS_API_PRODUCTION_POINTS_ADMIN"
    | "PPS_API_WRITING_OFFER"
    | "PPS_API_EDITING_OFFER"
    | "PPS_FLOW"
    | "PPS_FLOW_ADMIN"
    | "PPS_API_JOB"
    | "PPS_API_INVOICE"
    | "SCIM_TOKEN_VIEWER"
    | "PPS_API_OFFER"
    | "PRODUCTION_REPORT"
    | "PPS_RIGHTS_FLOW"
    | "PPS_AUTHOR_TOOL"
    | "GA_KNOWLEDGE_BASE"
    | "PPS_KNOWLEDGE_BASE"
    | "EDITORIAL_KNOWLEDGE_BASE"
    | "PPS_RIGHTS_TEAM_REPORTS"
    | "PPS_EDITORIAL_TEAM_REPORTS"
    | "PPS_API_SUMMARY_CREATION"
    | "PROMOTION_CODE_TOOL"
    | "PPS_GLOBAL_MOST_WANTED_SUMMARY_REPORT"
    | "ASP_LIST"
    | "PPS_USER_API"
    | "ASP_SENSITIVE_CONTENT"
    | "CHANNEL_ADMIN_SEARCH"
    | "PPS_TEAM_MOST_WANTED_EDITORIAL_SUMMARY_REPORT"
    | "PPS_PERSONAL_MOST_WANTED_EDITORIAL_SUMMARY_REPORT"
    | "PPS_TEAM_MOST_WANTED_RIGHTS_SUMMARY_REPORT"
    | "PPS_PERSONAL_MOST_WANTED_RIGHTS_SUMMARY_REPORT"
    | "ACTIONABLE_ADMIN"
    | "PPS_COMPONENT_DEMO"
    | "ASP_MASSIMPORT_TOOL_EXTENDED"
    | "ASP_UNIDENTIFIED_USER_ADMIN"
    | "PPS_PAYMENT_TOOL"
    | "HR_ADMIN_FULL_ACCESS"
    | "PPS_ORIGINAL_SUMMARY_FILE_ACCESS"
    | "CUSTOMER_REPORTS"
    | "PPS_ARCHIVING_SUMMARY"
    | "PPS_USER_BETA_TEST"
    | "ACTIONABLE_ADMIN_SEARCH"
    | "CUSTOM_PAGE_ADMIN"
    | "PPS_EXPENSE_TOOL"
    | "VERIFY_INPUT_TOOL"
    | "VERIFY_PUBLISH"
    | "VERIFY_UPLOAD"
    | "VERIFY_DASHBOARD"
    | "CSM_ADVANCED_SEARCH"
    | "VERIFY_VERIFICATION"
    | "VERIFY_EDITING"
    | "SUMMARIES_BULK_LOAD"
    | "ACTIONABLES_BULK_LOAD"
    | "VERIFY_BULK_LOAD"
    | "TAG_ADMIN"
    | "EXPERTVIDEO_ADMIN"
    | "MIAB_ADMIN"
    | "AUTHOR_READ"
    | "TAG_SUPER_ADMIN"
    | "SKILL_BOOST_ADMIN"
    | "TXT_READ_ONLY"
  > => {
    if (typeof value !== "string") {
      return { success: false, reason: `[#/components/schemas/RoleResource]: '${value}' expected to be of type string.` };
    }
    switch (value) {
      case "ROLE_ADMIN":
        return { success: true, value: "ROLE_ADMIN" };
      case "PPS_EDITORIAL":
        return { success: true, value: "PPS_EDITORIAL" };
      case "PPS_RIGHTS":
        return { success: true, value: "PPS_RIGHTS" };
      case "PPS_BOOKMARKETING":
        return { success: true, value: "PPS_BOOKMARKETING" };
      case "PPS_WRITERREPORT":
        return { success: true, value: "PPS_WRITERREPORT" };
      case "PPS_STANDARDREPORT":
        return { success: true, value: "PPS_STANDARDREPORT" };
      case "PPS_ALLSUMMARIES_LIST":
        return { success: true, value: "PPS_ALLSUMMARIES_LIST" };
      case "PPS_PUBLISHERADMIN":
        return { success: true, value: "PPS_PUBLISHERADMIN" };
      case "PPS_INTERNALSEARCH":
        return { success: true, value: "PPS_INTERNALSEARCH" };
      case "ASP_ACCOUNT_ADMIN":
        return { success: true, value: "ASP_ACCOUNT_ADMIN" };
      case "PUBLISHER_STATS_ALL":
        return { success: true, value: "PUBLISHER_STATS_ALL" };
      case "ASP_STATISTICS":
        return { success: true, value: "ASP_STATISTICS" };
      case "ASP_USER_ADMIN":
        return { success: true, value: "ASP_USER_ADMIN" };
      case "PPS_RIGHTSADMINLIST":
        return { success: true, value: "PPS_RIGHTSADMINLIST" };
      case "ASP_STATISTICS_INTERNAL":
        return { success: true, value: "ASP_STATISTICS_INTERNAL" };
      case "ADMIN_TOOL":
        return { success: true, value: "ADMIN_TOOL" };
      case "CUSTOMER_ADMIN":
        return { success: true, value: "CUSTOMER_ADMIN" };
      case "EMAILTOOL":
        return { success: true, value: "EMAILTOOL" };
      case "TRANSACTION_ADMIN":
        return { success: true, value: "TRANSACTION_ADMIN" };
      case "AFFILIATE_CLV_STATISTICS":
        return { success: true, value: "AFFILIATE_CLV_STATISTICS" };
      case "MARKETING_FILE_UPLOAD":
        return { success: true, value: "MARKETING_FILE_UPLOAD" };
      case "CURRENCY_EXCHANGE_RATE":
        return { success: true, value: "CURRENCY_EXCHANGE_RATE" };
      case "PPS_EDITORREPORT":
        return { success: true, value: "PPS_EDITORREPORT" };
      case "ADMIN_RELOAD":
        return { success: true, value: "ADMIN_RELOAD" };
      case "ASP_MASSIMPORT_TOOL":
        return { success: true, value: "ASP_MASSIMPORT_TOOL" };
      case "ASP_USER_ADMIN_LASTACCESS":
        return { success: true, value: "ASP_USER_ADMIN_LASTACCESS" };
      case "ASP_CENTRAL_ADMIN":
        return { success: true, value: "ASP_CENTRAL_ADMIN" };
      case "TXT_BUNDLE_EDIT":
        return { success: true, value: "TXT_BUNDLE_EDIT" };
      case "TXT_TEXT_SINGLEEDIT":
        return { success: true, value: "TXT_TEXT_SINGLEEDIT" };
      case "TXT_TEXT_MULTIEDIT":
        return { success: true, value: "TXT_TEXT_MULTIEDIT" };
      case "TXT_TOBEREVIEWEDLIST":
        return { success: true, value: "TXT_TOBEREVIEWEDLIST" };
      case "TXT_TOBETRANSLATEDLIST":
        return { success: true, value: "TXT_TOBETRANSLATEDLIST" };
      case "TXT_INLINE_EDIT":
        return { success: true, value: "TXT_INLINE_EDIT" };
      case "TXT_LATEST_CHANGES":
        return { success: true, value: "TXT_LATEST_CHANGES" };
      case "TXT_SEARCH":
        return { success: true, value: "TXT_SEARCH" };
      case "TXT_MAJOR_CHANGE":
        return { success: true, value: "TXT_MAJOR_CHANGE" };
      case "TXT_ONLINE_STATE":
        return { success: true, value: "TXT_ONLINE_STATE" };
      case "CREDIT_CARD_SETTLEMENT":
        return { success: true, value: "CREDIT_CARD_SETTLEMENT" };
      case "TXT_BUNDLE_VIEW":
        return { success: true, value: "TXT_BUNDLE_VIEW" };
      case "EMAIL_LIST":
        return { success: true, value: "EMAIL_LIST" };
      case "SOCIAL_COMMENT_FLAG":
        return { success: true, value: "SOCIAL_COMMENT_FLAG" };
      case "CUSTOMER_WRITER":
        return { success: true, value: "CUSTOMER_WRITER" };
      case "RECOMMENDER_EXPORT":
        return { success: true, value: "RECOMMENDER_EXPORT" };
      case "KREC_EDIT":
        return { success: true, value: "KREC_EDIT" };
      case "WEB_RIGHTS_REQUEST":
        return { success: true, value: "WEB_RIGHTS_REQUEST" };
      case "SCORM_PACKAGE":
        return { success: true, value: "SCORM_PACKAGE" };
      case "PPS_VIEW":
        return { success: true, value: "PPS_VIEW" };
      case "AFFILIATE_ADMIN":
        return { success: true, value: "AFFILIATE_ADMIN" };
      case "SUMMARY_QR_CODE":
        return { success: true, value: "SUMMARY_QR_CODE" };
      case "MARC_XML":
        return { success: true, value: "MARC_XML" };
      case "REGENERATE_SUMMARY_FILES":
        return { success: true, value: "REGENERATE_SUMMARY_FILES" };
      case "HR_ADMIN_TOOL":
        return { success: true, value: "HR_ADMIN_TOOL" };
      case "SUMMARY_STATISTICS":
        return { success: true, value: "SUMMARY_STATISTICS" };
      case "CF_SUBSCRIPTIONS":
        return { success: true, value: "CF_SUBSCRIPTIONS" };
      case "ASP_SSO_DOMAIN":
        return { success: true, value: "ASP_SSO_DOMAIN" };
      case "CUSTOMER_ADMIN_SUBSCRIPTION":
        return { success: true, value: "CUSTOMER_ADMIN_SUBSCRIPTION" };
      case "CUSTOMER_ADMIN_FINANCE":
        return { success: true, value: "CUSTOMER_ADMIN_FINANCE" };
      case "OAUTH2_CLIENT_ADMIN":
        return { success: true, value: "OAUTH2_CLIENT_ADMIN" };
      case "ASP_USER_GROUP_ADMIN":
        return { success: true, value: "ASP_USER_GROUP_ADMIN" };
      case "TOP_DOWNLOADS_TOOL":
        return { success: true, value: "TOP_DOWNLOADS_TOOL" };
      case "WRITER_PORTAL":
        return { success: true, value: "WRITER_PORTAL" };
      case "ASP_LOGO_UPLOAD":
        return { success: true, value: "ASP_LOGO_UPLOAD" };
      case "PORTLET_ADMIN":
        return { success: true, value: "PORTLET_ADMIN" };
      case "PORTLET_SUPER_ADMIN":
        return { success: true, value: "PORTLET_SUPER_ADMIN" };
      case "FREEABSTRACT_ADMIN_TOOL":
        return { success: true, value: "FREEABSTRACT_ADMIN_TOOL" };
      case "PROMOBOXES_ADMIN":
        return { success: true, value: "PROMOBOXES_ADMIN" };
      case "CORPORATE_CONTACT":
        return { success: true, value: "CORPORATE_CONTACT" };
      case "CORPORATE_COMMENTS":
        return { success: true, value: "CORPORATE_COMMENTS" };
      case "PPS_NEW_CONTENT_INPUT":
        return { success: true, value: "PPS_NEW_CONTENT_INPUT" };
      case "PPS_NEW_CONTENT_INPUT_ADMIN":
        return { success: true, value: "PPS_NEW_CONTENT_INPUT_ADMIN" };
      case "ABSENCES_ADMIN":
        return { success: true, value: "ABSENCES_ADMIN" };
      case "CHANNEL_ADMIN":
        return { success: true, value: "CHANNEL_ADMIN" };
      case "PROMOBOXES":
        return { success: true, value: "PROMOBOXES" };
      case "SSO_DOMAINS":
        return { success: true, value: "SSO_DOMAINS" };
      case "PPS_PORTAL":
        return { success: true, value: "PPS_PORTAL" };
      case "PPS_PORTAL_ADMIN":
        return { success: true, value: "PPS_PORTAL_ADMIN" };
      case "CHANNEL_LIST":
        return { success: true, value: "CHANNEL_LIST" };
      case "B2B_STATISTICS":
        return { success: true, value: "B2B_STATISTICS" };
      case "LIBRARY_CONNECTOR":
        return { success: true, value: "LIBRARY_CONNECTOR" };
      case "CHANNEL_ADMIN_GLOBAL":
        return { success: true, value: "CHANNEL_ADMIN_GLOBAL" };
      case "PPS_FREELANCER_CONTACT_TOOL":
        return { success: true, value: "PPS_FREELANCER_CONTACT_TOOL" };
      case "PPS_API_PRODUCTION_POINTS":
        return { success: true, value: "PPS_API_PRODUCTION_POINTS" };
      case "PPS_API_PRODUCTION_POINTS_ADMIN":
        return { success: true, value: "PPS_API_PRODUCTION_POINTS_ADMIN" };
      case "PPS_API_WRITING_OFFER":
        return { success: true, value: "PPS_API_WRITING_OFFER" };
      case "PPS_API_EDITING_OFFER":
        return { success: true, value: "PPS_API_EDITING_OFFER" };
      case "PPS_FLOW":
        return { success: true, value: "PPS_FLOW" };
      case "PPS_FLOW_ADMIN":
        return { success: true, value: "PPS_FLOW_ADMIN" };
      case "PPS_API_JOB":
        return { success: true, value: "PPS_API_JOB" };
      case "PPS_API_INVOICE":
        return { success: true, value: "PPS_API_INVOICE" };
      case "SCIM_TOKEN_VIEWER":
        return { success: true, value: "SCIM_TOKEN_VIEWER" };
      case "PPS_API_OFFER":
        return { success: true, value: "PPS_API_OFFER" };
      case "PRODUCTION_REPORT":
        return { success: true, value: "PRODUCTION_REPORT" };
      case "PPS_RIGHTS_FLOW":
        return { success: true, value: "PPS_RIGHTS_FLOW" };
      case "PPS_AUTHOR_TOOL":
        return { success: true, value: "PPS_AUTHOR_TOOL" };
      case "GA_KNOWLEDGE_BASE":
        return { success: true, value: "GA_KNOWLEDGE_BASE" };
      case "PPS_KNOWLEDGE_BASE":
        return { success: true, value: "PPS_KNOWLEDGE_BASE" };
      case "EDITORIAL_KNOWLEDGE_BASE":
        return { success: true, value: "EDITORIAL_KNOWLEDGE_BASE" };
      case "PPS_RIGHTS_TEAM_REPORTS":
        return { success: true, value: "PPS_RIGHTS_TEAM_REPORTS" };
      case "PPS_EDITORIAL_TEAM_REPORTS":
        return { success: true, value: "PPS_EDITORIAL_TEAM_REPORTS" };
      case "PPS_API_SUMMARY_CREATION":
        return { success: true, value: "PPS_API_SUMMARY_CREATION" };
      case "PROMOTION_CODE_TOOL":
        return { success: true, value: "PROMOTION_CODE_TOOL" };
      case "PPS_GLOBAL_MOST_WANTED_SUMMARY_REPORT":
        return { success: true, value: "PPS_GLOBAL_MOST_WANTED_SUMMARY_REPORT" };
      case "ASP_LIST":
        return { success: true, value: "ASP_LIST" };
      case "PPS_USER_API":
        return { success: true, value: "PPS_USER_API" };
      case "ASP_SENSITIVE_CONTENT":
        return { success: true, value: "ASP_SENSITIVE_CONTENT" };
      case "CHANNEL_ADMIN_SEARCH":
        return { success: true, value: "CHANNEL_ADMIN_SEARCH" };
      case "PPS_TEAM_MOST_WANTED_EDITORIAL_SUMMARY_REPORT":
        return { success: true, value: "PPS_TEAM_MOST_WANTED_EDITORIAL_SUMMARY_REPORT" };
      case "PPS_PERSONAL_MOST_WANTED_EDITORIAL_SUMMARY_REPORT":
        return { success: true, value: "PPS_PERSONAL_MOST_WANTED_EDITORIAL_SUMMARY_REPORT" };
      case "PPS_TEAM_MOST_WANTED_RIGHTS_SUMMARY_REPORT":
        return { success: true, value: "PPS_TEAM_MOST_WANTED_RIGHTS_SUMMARY_REPORT" };
      case "PPS_PERSONAL_MOST_WANTED_RIGHTS_SUMMARY_REPORT":
        return { success: true, value: "PPS_PERSONAL_MOST_WANTED_RIGHTS_SUMMARY_REPORT" };
      case "ACTIONABLE_ADMIN":
        return { success: true, value: "ACTIONABLE_ADMIN" };
      case "PPS_COMPONENT_DEMO":
        return { success: true, value: "PPS_COMPONENT_DEMO" };
      case "ASP_MASSIMPORT_TOOL_EXTENDED":
        return { success: true, value: "ASP_MASSIMPORT_TOOL_EXTENDED" };
      case "ASP_UNIDENTIFIED_USER_ADMIN":
        return { success: true, value: "ASP_UNIDENTIFIED_USER_ADMIN" };
      case "PPS_PAYMENT_TOOL":
        return { success: true, value: "PPS_PAYMENT_TOOL" };
      case "HR_ADMIN_FULL_ACCESS":
        return { success: true, value: "HR_ADMIN_FULL_ACCESS" };
      case "PPS_ORIGINAL_SUMMARY_FILE_ACCESS":
        return { success: true, value: "PPS_ORIGINAL_SUMMARY_FILE_ACCESS" };
      case "CUSTOMER_REPORTS":
        return { success: true, value: "CUSTOMER_REPORTS" };
      case "PPS_ARCHIVING_SUMMARY":
        return { success: true, value: "PPS_ARCHIVING_SUMMARY" };
      case "PPS_USER_BETA_TEST":
        return { success: true, value: "PPS_USER_BETA_TEST" };
      case "ACTIONABLE_ADMIN_SEARCH":
        return { success: true, value: "ACTIONABLE_ADMIN_SEARCH" };
      case "CUSTOM_PAGE_ADMIN":
        return { success: true, value: "CUSTOM_PAGE_ADMIN" };
      case "PPS_EXPENSE_TOOL":
        return { success: true, value: "PPS_EXPENSE_TOOL" };
      case "VERIFY_INPUT_TOOL":
        return { success: true, value: "VERIFY_INPUT_TOOL" };
      case "VERIFY_PUBLISH":
        return { success: true, value: "VERIFY_PUBLISH" };
      case "VERIFY_UPLOAD":
        return { success: true, value: "VERIFY_UPLOAD" };
      case "VERIFY_DASHBOARD":
        return { success: true, value: "VERIFY_DASHBOARD" };
      case "CSM_ADVANCED_SEARCH":
        return { success: true, value: "CSM_ADVANCED_SEARCH" };
      case "VERIFY_VERIFICATION":
        return { success: true, value: "VERIFY_VERIFICATION" };
      case "VERIFY_EDITING":
        return { success: true, value: "VERIFY_EDITING" };
      case "SUMMARIES_BULK_LOAD":
        return { success: true, value: "SUMMARIES_BULK_LOAD" };
      case "ACTIONABLES_BULK_LOAD":
        return { success: true, value: "ACTIONABLES_BULK_LOAD" };
      case "VERIFY_BULK_LOAD":
        return { success: true, value: "VERIFY_BULK_LOAD" };
      case "TAG_ADMIN":
        return { success: true, value: "TAG_ADMIN" };
      case "EXPERTVIDEO_ADMIN":
        return { success: true, value: "EXPERTVIDEO_ADMIN" };
      case "MIAB_ADMIN":
        return { success: true, value: "MIAB_ADMIN" };
      case "AUTHOR_READ":
        return { success: true, value: "AUTHOR_READ" };
      case "TAG_SUPER_ADMIN":
        return { success: true, value: "TAG_SUPER_ADMIN" };
      case "SKILL_BOOST_ADMIN":
        return { success: true, value: "SKILL_BOOST_ADMIN" };
      case "TXT_READ_ONLY":
        return { success: true, value: "TXT_READ_ONLY" };
      default:
        return {
          success: false,
          reason: `[#/components/schemas/RoleResource]: '${value}' expected to be enum, one of 'ROLE_ADMIN, PPS_EDITORIAL, PPS_RIGHTS, PPS_BOOKMARKETING, PPS_WRITERREPORT, PPS_STANDARDREPORT, PPS_ALLSUMMARIES_LIST, PPS_PUBLISHERADMIN, PPS_INTERNALSEARCH, ASP_ACCOUNT_ADMIN, PUBLISHER_STATS_ALL, ASP_STATISTICS, ASP_USER_ADMIN, PPS_RIGHTSADMINLIST, ASP_STATISTICS_INTERNAL, ADMIN_TOOL, CUSTOMER_ADMIN, EMAILTOOL, TRANSACTION_ADMIN, AFFILIATE_CLV_STATISTICS, MARKETING_FILE_UPLOAD, CURRENCY_EXCHANGE_RATE, PPS_EDITORREPORT, ADMIN_RELOAD, ASP_MASSIMPORT_TOOL, ASP_USER_ADMIN_LASTACCESS, ASP_CENTRAL_ADMIN, TXT_BUNDLE_EDIT, TXT_TEXT_SINGLEEDIT, TXT_TEXT_MULTIEDIT, TXT_TOBEREVIEWEDLIST, TXT_TOBETRANSLATEDLIST, TXT_INLINE_EDIT, TXT_LATEST_CHANGES, TXT_SEARCH, TXT_MAJOR_CHANGE, TXT_ONLINE_STATE, CREDIT_CARD_SETTLEMENT, TXT_BUNDLE_VIEW, EMAIL_LIST, SOCIAL_COMMENT_FLAG, CUSTOMER_WRITER, RECOMMENDER_EXPORT, KREC_EDIT, WEB_RIGHTS_REQUEST, SCORM_PACKAGE, PPS_VIEW, AFFILIATE_ADMIN, SUMMARY_QR_CODE, MARC_XML, REGENERATE_SUMMARY_FILES, HR_ADMIN_TOOL, SUMMARY_STATISTICS, CF_SUBSCRIPTIONS, ASP_SSO_DOMAIN, CUSTOMER_ADMIN_SUBSCRIPTION, CUSTOMER_ADMIN_FINANCE, OAUTH2_CLIENT_ADMIN, ASP_USER_GROUP_ADMIN, TOP_DOWNLOADS_TOOL, WRITER_PORTAL, ASP_LOGO_UPLOAD, PORTLET_ADMIN, PORTLET_SUPER_ADMIN, FREEABSTRACT_ADMIN_TOOL, PROMOBOXES_ADMIN, CORPORATE_CONTACT, CORPORATE_COMMENTS, PPS_NEW_CONTENT_INPUT, PPS_NEW_CONTENT_INPUT_ADMIN, ABSENCES_ADMIN, CHANNEL_ADMIN, PROMOBOXES, SSO_DOMAINS, PPS_PORTAL, PPS_PORTAL_ADMIN, CHANNEL_LIST, B2B_STATISTICS, LIBRARY_CONNECTOR, CHANNEL_ADMIN_GLOBAL, PPS_FREELANCER_CONTACT_TOOL, PPS_API_PRODUCTION_POINTS, PPS_API_PRODUCTION_POINTS_ADMIN, PPS_API_WRITING_OFFER, PPS_API_EDITING_OFFER, PPS_FLOW, PPS_FLOW_ADMIN, PPS_API_JOB, PPS_API_INVOICE, SCIM_TOKEN_VIEWER, PPS_API_OFFER, PRODUCTION_REPORT, PPS_RIGHTS_FLOW, PPS_AUTHOR_TOOL, GA_KNOWLEDGE_BASE, PPS_KNOWLEDGE_BASE, EDITORIAL_KNOWLEDGE_BASE, PPS_RIGHTS_TEAM_REPORTS, PPS_EDITORIAL_TEAM_REPORTS, PPS_API_SUMMARY_CREATION, PROMOTION_CODE_TOOL, PPS_GLOBAL_MOST_WANTED_SUMMARY_REPORT, ASP_LIST, PPS_USER_API, ASP_SENSITIVE_CONTENT, CHANNEL_ADMIN_SEARCH, PPS_TEAM_MOST_WANTED_EDITORIAL_SUMMARY_REPORT, PPS_PERSONAL_MOST_WANTED_EDITORIAL_SUMMARY_REPORT, PPS_TEAM_MOST_WANTED_RIGHTS_SUMMARY_REPORT, PPS_PERSONAL_MOST_WANTED_RIGHTS_SUMMARY_REPORT, ACTIONABLE_ADMIN, PPS_COMPONENT_DEMO, ASP_MASSIMPORT_TOOL_EXTENDED, ASP_UNIDENTIFIED_USER_ADMIN, PPS_PAYMENT_TOOL, HR_ADMIN_FULL_ACCESS, PPS_ORIGINAL_SUMMARY_FILE_ACCESS, CUSTOMER_REPORTS, PPS_ARCHIVING_SUMMARY, PPS_USER_BETA_TEST, ACTIONABLE_ADMIN_SEARCH, CUSTOM_PAGE_ADMIN, PPS_EXPENSE_TOOL, VERIFY_INPUT_TOOL, VERIFY_PUBLISH, VERIFY_UPLOAD, VERIFY_DASHBOARD, CSM_ADVANCED_SEARCH, VERIFY_VERIFICATION, VERIFY_EDITING, SUMMARIES_BULK_LOAD, ACTIONABLES_BULK_LOAD, VERIFY_BULK_LOAD, TAG_ADMIN, EXPERTVIDEO_ADMIN, MIAB_ADMIN, AUTHOR_READ, TAG_SUPER_ADMIN, SKILL_BOOST_ADMIN, TXT_READ_ONLY'.`,
        };
    }
  })(value);
}
export function deserialize_RoleResource(str: string): ParserResult<RoleResource> {
  return deserialize_RoleResource_internal(parseJsonWithNumbersAsBigint(str));
}
